import { React, useContext } from 'react';
import { withRouter } from 'react-router';
import { SiteContext } from 'site/SiteContext';
import { Alert } from 'dma-ui-kit';
import { isBefore } from 'date-fns';

const SiteAlert = () => {
    const { siteData } = useContext(SiteContext);
    let activeAlert = '';

    if (siteData && siteData.site_alerts) {
        const activeAlerts = siteData.site_alerts.filter(alert => 
            isBefore(Date.parse(alert.start), new Date) &&
            isBefore(new Date, Date.parse(alert.end))
        );
        if (activeAlerts[0])
            activeAlert = (<Alert message={activeAlerts[0].alert_text} />);
    }

    return (
        <>
            {activeAlert}
        </>
    );
};

export default withRouter(SiteAlert);